import { type OrganizationList, createOrganizationList } from 'models/organization';
import type { OrganizationContentObjectDataObject, OrganizationContentObjectDetailDataObject } from 'models/service';
import { type BaseContentObject, createBaseContentObject } from '../base-content-object';

export type OrganizationContentObject = {
  organization: OrganizationList;
} & BaseContentObject;

export const createOrganizationContentObject = (
  data: OrganizationContentObjectDataObject,
): OrganizationContentObject => ({
  ...createBaseContentObject(data),
  organization: createOrganizationList(data.organization),
});

export type OrganizationContentObjectDetail = {
  contentableType: 'Organization';
} & OrganizationContentObject;

export const createOrganizationContentObjectDetail = (
  data: OrganizationContentObjectDetailDataObject,
): OrganizationContentObjectDetail => ({
  ...createOrganizationContentObject(data),
  contentableType: 'Organization',
});
